module.exports = __webpack_public_path__ + "7862c702f0ac9f5a13ef7eea639b90db.png";